import React from "react";
import TicketDashboardLanding from "./TicketDashboardLanding";

const TicketLanding = ({ userInfoData }) => {
  return <TicketDashboardLanding userInfoData={userInfoData} />;
};

export default TicketLanding;
